import React, { useRef, useState } from "react";
import { Box, Button, Grid, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import QuestionField, {
  isAutoAdvanceQuestion,
} from "../../Profile/components/EventProfile/components/QuestionField";
import { hasMeaningfulAnswer } from "../../../utilities/checkInReadiness";

const ADVANCE_DELAY_MS = 350;

const QuestionStep = ({ question, onAnswer, onComplete }) => {
  const { t } = useTranslation();
  const advanceTimer = useRef(null);
  const [arrivedAnswered] = useState(() =>
    hasMeaningfulAnswer(question?.answer)
  );

  const handleChange = (questionId, answer) => {
    onAnswer(questionId, answer);
    if (!hasMeaningfulAnswer(answer)) return;
    if (!isAutoAdvanceQuestion(question)) return;
    if (advanceTimer.current) clearTimeout(advanceTimer.current);
    advanceTimer.current = setTimeout(onComplete, ADVANCE_DELAY_MS);
  };

  React.useEffect(() => {
    return () => {
      if (advanceTimer.current) clearTimeout(advanceTimer.current);
    };
  }, []);

  const answered = hasMeaningfulAnswer(question?.answer);
  const showNext = !isAutoAdvanceQuestion(question) || arrivedAnswered;

  return (
    <Box>
      <Typography variant="h5" sx={{ mb: question?.description ? 1 : 3 }}>
        {question?.question}
      </Typography>

      {question?.description && (
        <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
          {question.description}
        </Typography>
      )}

      <Grid container spacing={3} sx={{ mt: 0, mb: 3 }}>
        <QuestionField
          question={question}
          onChange={handleChange}
          hideLabel
          commitOnChange
          multiHint={t("setup.question.multihint")}
          placeholder={
            question?.questionType === "text"
              ? t("setup.question.placeholder.text")
              : t("setup.question.placeholder")
          }
        />
      </Grid>

      {showNext && (
        <Button
          className="tnfm-pill-btn"
          variant="contained"
          fullWidth
          disabled={!answered}
          onClick={onComplete}
        >
          {t("setup.continue")}
        </Button>
      )}
    </Box>
  );
};

export default QuestionStep;
